export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/bafcb97f65150dd63b7cabadb0e0f790.svg";